<div role="alert">
	@if (alert()) {
		<div class="global-alert" #container>
			<icon glyph="alert-circle" aria-hidden="true" />
			<div [innerHTML]="alert()"></div>
		</div>
	}
</div>
